import React from 'react';
import { Form, Input, Row, Col, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const AddDeviceConfigModal = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { TextArea } = Input;

  const validateJson = (_, value) => {
    if (!value) {
      return Promise.reject(new Error(t('DeviceConfigPage.addModal.configRequired')));
    }
    try {
      JSON.parse(value);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(new Error(t('DeviceConfigPage.addModal.configInvalid')));
    }
  };

  const onFinish = (values) => {
    props.action(values.version, values.description, values.configJson);
    form.resetFields();
    props.close();
  };

  return (
    <Modal
      title={t("DeviceConfigPage.addDeviceConfig")}
      open={props.visible}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={16}>
          <Col span={24} lg={24}>
            <Form.Item
              label={t("DeviceConfigPage.addModal.version")}
              name="version"
              rules={[{ required: true, message: t("DeviceConfigPage.addModal.versionRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={24}>
            <Form.Item
              label={t("DeviceConfigPage.addModal.description")}
              name="description"
              rules={[{ required: true, message: t("DeviceConfigPage.addModal.descriptionRequired") }]}
            >
              <TextArea />
            </Form.Item>
          </Col>
          <Col span={24} lg={24}>
            <Form.Item
              label={t("DeviceConfigPage.addModal.config")}
              name="configJson"
              rules={[{ validator: validateJson }]}
            >
              <TextArea
                rows={10}
                style={{ fontFamily: 'monospace' }}
                placeholder={t("DeviceConfigPage.addModal.configPlaceholder")}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddDeviceConfigModal;
